<template>
  <div>
    <b-card
      no-body
      class="overflow-hidden"
      id="cardproject"
      style="max-width: 600px; border-radius: 15px; cursor: pointer; b"
    >
      <b-row no-gutters>
        <b-col md="6" class="m-auto" style="padding: 10px">
          <b-card-img
            :src="image"
            alt="Image"
            v-on:click="openLink(link)"
            class="rounded-0"
            style="height: 100%; width: 100%"
          ></b-card-img>
        </b-col>
        <b-col md="6" style="padding: 20px 5px; background: rgb(92 163 129)">
          <b-card-body
            v-on:click="openLink(link)"
            :title="title"
            style="font-family: Poppins, sans-serif; padding-bottom: 0px"
          >
            <b-card-text class="text-overline">
              {{ description }}
            </b-card-text>
            <b-container class="bv-example-row" style="justify-content: center">
              <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="3">
                <b-col v-for="item in stack" :key="item">
                  <v-btn :icon="item" variant="text"></v-btn>
                </b-col>
              </b-row>
            </b-container>
          </b-card-body>
          <a :href="github" target="_blank">
            <v-btn
              aria-label="My Account"
              icon="mdi-github"
              variant="text"
              color="white"
            ></v-btn>
          </a>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    title: String,
    description: String,
    link: String,
    stack: Array,
    github: String,
  },
  methods: {
    openLink(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style scoped>
#cardproject {
  box-shadow: 5px 15px 15px 5px rgba(0, 0, 0, 0.2);
}

a {
  text-decoration: none;
}
</style>
